var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { useRef, useState } from "react";
import Logger from "../../../../services/logger/logger";
export const POST_SUBMIT_ACTION = {
  SHOW_SUCCESS_MESSAGE: "show_success_message",
  REDIRECT_TO_URL: "redirect_to_url",
  HIDE_THE_FORM: "hide_the_form"
};
const formSubmissionHeaders = {
  deviceFingerprint: "X-TINT-Device-Fingerprint",
  tintAnonymousUid: "X-TINT-Anonymous-UID",
  jwtToken: "Authorization",
  metadata: "X-TINT-Metadata"
};
const formatFormData = (formDataObj) => {
  if (!formDataObj) return;
  const newFormData = new FormData();
  const formDataObjCopy = __spreadValues({}, formDataObj);
  for (const [inputName, inputValue] of Object.entries(formDataObjCopy)) {
    if (!(inputValue instanceof File) && !Array.isArray(inputValue) && !(inputValue == null ? void 0 : inputValue.filesIds)) {
      newFormData.append(inputName, inputValue);
    }
    if (Array.isArray(inputValue)) {
      for (const value of inputValue) {
        newFormData.append(inputName, value);
      }
    }
    if (inputValue == null ? void 0 : inputValue.filesIds) {
      for (const value of inputValue.filesIds) {
        newFormData.append(inputName, value);
      }
    }
  }
  return newFormData;
};
export const useFormSubmit = ({ headersValues, hostElement, actionUrl, layout, analyticForm, formData, formRef }) => {
  const submitButtonRef = useRef();
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [isSubmissionPending, setIsSubmissionPending] = useState(false);
  const applyHeaders = () => {
    var _a, _b, _c;
    const headers = {};
    const { accessToken, metadata } = headersValues;
    const deviceFingerprint = window.bbDeviceFingerprint;
    const zinreloToken = accessToken || (window.eudSettings ? window.accessToken : (_b = (_a = window.zrl_mi) == null ? void 0 : _a.init_data) == null ? void 0 : _b.jwt_token);
    const anonymousUid = (_c = window.Tint) == null ? void 0 : _c.anonymous_uid;
    if (anonymousUid) headers[formSubmissionHeaders.tintAnonymousUid] = anonymousUid;
    if (deviceFingerprint) headers[formSubmissionHeaders.deviceFingerprint] = deviceFingerprint;
    if (zinreloToken) headers[formSubmissionHeaders.jwtToken] = `Bearer ${zinreloToken}`;
    if (metadata) headers[formSubmissionHeaders.metadata] = metadata;
    return headers;
  };
  const handleSubmit = (e) => __async(void 0, null, function* () {
    var _a, _b, _c;
    e.preventDefault();
    if (isSubmissionPending) return;
    setIsSubmissionPending(true);
    const formattedFormData = formatFormData(formData);
    const headers = applyHeaders();
    try {
      const response = yield fetch(actionUrl, {
        method: "POST",
        body: formattedFormData,
        headers,
        referrerPolicy: "no-referrer-when-downgrade"
      });
      const responseq = yield response.json();
      if (!response.ok) {
        const error = (_a = responseq == null ? void 0 : responseq.errors) == null ? void 0 : _a[0];
        throw new Error((error == null ? void 0 : error.detail) || (error == null ? void 0 : error.title) || (error == null ? void 0 : error.status));
      }
      try {
        setShowSuccessMessage(
          ((_b = layout == null ? void 0 : layout.postSubmit) == null ? void 0 : _b.action) === POST_SUBMIT_ACTION.SHOW_SUCCESS_MESSAGE || !((_c = layout == null ? void 0 : layout.postSubmit) == null ? void 0 : _c.action)
        );
        (() => __async(void 0, null, function* () {
          yield analyticForm == null ? void 0 : analyticForm.trackFormSubmitted();
          hostElement.dispatchEvent(new CustomEvent("afterSubmit", { detail: responseq }));
        }))();
      } catch (error) {
        Logger.error("Error in afterSubmit function", error);
      }
    } catch (error) {
      submitButtonRef.current.setCustomValidity(error.message);
      submitButtonRef.current.reportValidity();
      setIsSubmissionPending(false);
      Logger.error("There was an error submitting the form!", error);
    }
  });
  const onSubmitRequest = (e) => {
    e.preventDefault();
    submitButtonRef.current.setCustomValidity("");
    if (hostElement.dispatchEvent(new CustomEvent("beforeSubmit", { cancelable: true }))) {
      formRef.current.requestSubmit();
    } else {
      setIsSubmissionPending(false);
    }
  };
  return { handleSubmit, showSuccessMessage, onSubmitRequest, submitButtonRef };
};
